<template>
  <l-marker
    :lat-lng="item.geopoints"
    :zIndexOffset="1"
  >
    <l-icon
      :icon-size="iconSize()"
      :icon-anchor="iconAnchor()"
    >
      <div 
        class="icon-stop"
        :style="iconStyle()"
      ></div>
    </l-icon>
  </l-marker>
</template>

<script>
import * as Vue2Leaflet from 'vue2-leaflet'
import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl

export default {
  name: 'c-map-item-stop',
  components: {
    'l-marker': Vue2Leaflet.LMarker,
    'l-icon': Vue2Leaflet.LIcon,
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      }
    },
    color: {
      type: String,
      default: `#999`
    },
    icon_size: {
      type: Number,
      default: 10
    },
    icon_border_width: {
      type: Number,
      default: 2
    }
  },
  methods: {
    iconSize() {
      let val = this.icon_size + this.icon_border_width
      return [val, val]
    },
    iconAnchor() {
      let val = this.iconSize()[0] / 2
      return [val, val]
    },
    iconStyle() {
      let size = this.iconSize()[0]
      return `background: ${this.color}; width: ${size}px; height: ${size}px; border-width: ${this.icon_border_width}px;`
    }
  }
}
</script>

<style lang="scss">
  .leaflet-marker-icon {
    .icon-stop {
      border: 2px solid #FFFFFF;
      border-radius: 50%;
    }
  }
</style>